import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Container } from './styles';

const FilterBtn: React.FC = ({ children }) => {
  return (
    <Container
      icon={<SearchOutlined />}
      data-cy="btnFiltrar"
      type="primary"
      size="middle"
      block
      htmlType="submit"
    >
      {children}
    </Container>
  );
};

export default FilterBtn;
